export const RED = "#b72026";
export const GREY = "#666666";
export const BLUE = "#3b78ab";